import { useRecoilState, useRecoilValue } from 'recoil';
import React from 'react';
import OnlinePanel from './OnlinePanel';
import LastRidePanel from '../../RidePlayer/LastRidePanel';
import { IRide, IRidePosition } from '../../RidePlayer/types';
import RidePlayer from '../../RidePlayer';
import { BluecoinPanel } from '../Bluecoins/BluecoinPanel';
import PermissionsService, { PERMISSION_BLUECOINS } from '../../../Services/PermissionsService';
import { selectedCustomersAtom } from '../../../store/recoil/customers';
import { isOnlinePanelOpenAtom } from '../../OnlinePanel/OnlinePanelState';
import { isBluecoinListPanelOpenAtom, isBluecoinPanelOpenAtom } from '../Bluecoins/BluecoinState';
import {
  currentRidePositionForSelectedVehicleAtom,
  isRidePlayerOpenAtom,
  lastRideForSelectedVehicleAtom,
} from '../OnlineMapState';
import { BluecoinListPanel } from '../Bluecoins/BluecoinListPanel';

interface IPanelsLayerProps {
  googleMap: google.maps.Map | undefined;
}

function PanelsLayer(props: IPanelsLayerProps): React.JSX.Element {
  const [isRidePlayerOpen, setIsRidePlayerOpen] = useRecoilState<number | boolean>(
    isRidePlayerOpenAtom
  );
  const isOnlinePanelOpen = useRecoilValue<number | false>(isOnlinePanelOpenAtom);
  const lastRideForSelectedVehicle = useRecoilValue<IRide | null>(lastRideForSelectedVehicleAtom);
  const currentRidePositionForSelectedVehicle = useRecoilValue<IRidePosition | null>(
    currentRidePositionForSelectedVehicleAtom
  );
  const selectedCustomers = useRecoilValue<number[]>(selectedCustomersAtom);
  const isBluecoinPanelOpen = useRecoilValue<number | false>(isBluecoinPanelOpenAtom);
  const isBluecoinListPanelOpen = useRecoilValue<number[] | false>(isBluecoinListPanelOpenAtom);

  return (
    <>
      {isBluecoinPanelOpen &&
        PermissionsService.hasAccess(PERMISSION_BLUECOINS, ['read'], selectedCustomers) && (
          <BluecoinPanel />
        )}
      {isBluecoinListPanelOpen &&
        !isBluecoinPanelOpen &&
        props.googleMap &&
        PermissionsService.hasAccess(PERMISSION_BLUECOINS, ['read'], selectedCustomers) && (
          <BluecoinListPanel map={props.googleMap} />
        )}
      {isOnlinePanelOpen && (
        <OnlinePanel
          isRidePlayerOpen={isRidePlayerOpen}
          setIsRidePlayerOpen={setIsRidePlayerOpen}
        />
      )}
      {isRidePlayerOpen && isOnlinePanelOpen && lastRideForSelectedVehicle && (
        <LastRidePanel
          rides={[lastRideForSelectedVehicle]}
          setIsRidePlayerOpen={setIsRidePlayerOpen}
        />
      )}
      {/* {Config.Player.debug.showPositionIndex &&
        isOnlinePanelOpen &&
        isRidePlayerOpen &&
        lastRideForSelectedVehicle && <RidePlayerDebugPanel rides={[lastRideForSelectedVehicle]} />} */}
      {props.googleMap && isOnlinePanelOpen && isRidePlayerOpen && lastRideForSelectedVehicle && (
        <RidePlayer
          rides={[lastRideForSelectedVehicle]}
          // unmountCallback={handleRidePlayerUnmount}
          googleMap={props.googleMap}
          actualVehiclePosition={currentRidePositionForSelectedVehicle}
          isLastRidePlayer={true}
        />
      )}
    </>
  );
}

export default PanelsLayer;
